class ImgSrc {
    constructor() {
        this.url = process.env.NODE_ENV === 'development' ? 'http://www.sports.local:8080/statics/sports/images/' : 'https://sports.rgrimaldi.com/images/';
    }
    get(picture) {
        return this.url + picture;
    }
}

export default ImgSrc;